import React from 'react';
import './Footer.css';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <div className="footer-logo">
            <svg width="22" height="22" viewBox="0 0 32 32" fill="none">
              <path d="M6 24 L6 8 L16 22 L16 8" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="24" cy="22" r="3" fill="currentColor"/>
            </svg>
            <span>NeuraScan</span>
          </div>
          <p className="footer-tag">
            Sistem Klasifikasi Jenis Kejang pada Anak Berbasis Machine Learning
          </p>
        </div>

        <div className="footer-meta">
          <div className="footer-row">
            <span className="footer-label">Nama</span>
            <span className="footer-value">Adzanta Al Farizal</span>
          </div>
          <div className="footer-row">
            <span className="footer-label">Email</span>
            <a className="footer-value link" href="mailto:adzantaf@gmail.com">
              adzantaf@gmail.com
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <span>© {year} NeuraScan — Copyright oleh Adzanta Al Farizal</span>
        <span className="dot">·</span>
        <span>Penulisan Ilmiah Universitas Gunadarma</span>
      </div>
    </footer>
  );
}
